export const employeeFormMap = {
  firstName: 'first name',
  lastName: 'last name',
  email: 'email',
  phone: 'phone',
  salary: 'salary',
  iban: 'iban',
  personalId: 'personal id',
  payrollId: 'payroll id'
};
